import React from 'react'

import classnames from 'classnames'
import Immutable from 'immutable'

import { Crop } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import GoustoImage from 'components/Image'

import { SoldOutOverlay } from '../../Recipe/SoldOutOverlay'
import { DetailViewType } from '../types'

import css from './DetailImage.css'

type DetailImageProps = {
  media: Crop[]
  title?: string
  view?: DetailViewType
  mouseEnter?: () => void
  mouseLeave?: () => void
  maxMediaSize?: number | null
  lazy?: boolean
}

export const DetailImage = ({
  media,
  title = '',
  view = 'standard',
  mouseEnter = () => {},
  mouseLeave = () => {},
  maxMediaSize = null,
  lazy = true,
}: DetailImageProps) => (
  <div
    className={classnames(
      { [css.large]: view === 'large' },
      { [css.standard]: view === 'standard' },
      css.placeholder,
    )}
    onMouseEnter={mouseEnter}
    onMouseLeave={mouseLeave}
    data-testid="detail-image"
  >
    {/* Showing SoldOutOverlay when the recipe does not have media is slightly
    misleading. Maybe it is worth bringing special replacer instead? */}
    {media.length > 0 && <SoldOutOverlay />}
    {media.length > 0 && (
      <GoustoImage
        media={Immutable.fromJS(media)}
        title={title}
        maxMediaSize={maxMediaSize}
        className={css.recipeImg}
        lazy={lazy}
      />
    )}
  </div>
)
